export default function scrollToFilter() {
	setTimeout(() => {
		window.scrollTo({ top: 310, behavior: 'smooth' })
	}, 1);
}